import axios from '@/libs/api.request'

export const getPopupList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/popup'
  })
}

export const addPopup = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/popup'
  })
}

export const editPopup = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/popup'
  })
}

export const changePopupStatus = (id) => {
  return axios.request({
    method: 'put',
    url: '/popup/status/' + id
  })
}

export const getPopupInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/popup/' + id
  })
}

export const delPopup = (id) => {
  return axios.request({
    method: 'delete',
    url: '/popup/' + id
  })
}

export const getJumpOptions = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/popup/custom/jump-options'
  })
}

// ========== 弹窗测试定向规则接口 ==========
// 接口地址: /popup/target

// GET - 分页获取弹窗定向规则信息
// 参数: current, size, popupName, userId, triggerTiming, remark
export const getPopupTestList = (params) => {
  return axios.request({
    method: 'get',
    params,
    url: '/popup/target'
  })
}

// POST - 添加弹窗定向规则
// 参数: popupId, userIds(逗号分隔字符串), triggerTiming, targetType, remark
export const addPopupTest = (data) => {
  return axios.request({
    method: 'post',
    data,
    url: '/popup/target'
  })
}

// PUT - 编辑弹窗定向规则
// 参数: id, popupId, userIds, triggerTiming, targetType, remark
export const editPopupTest = (data) => {
  return axios.request({
    method: 'put',
    data,
    url: '/popup/target'
  })
}

// GET - 根据id获取弹窗定向规则
export const getPopupTestInfo = (id) => {
  return axios.request({
    method: 'get',
    url: '/popup/target/' + id
  })
}

// DELETE - 删除弹窗定向规则
export const delPopupTest = (id) => {
  return axios.request({
    method: 'delete',
    url: '/popup/target/' + id
  })
}


